<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <custom-divider label="تنظیمات کلی تیکت"></custom-divider>
            <v-checkbox class="mt-0 mb-2" hide-details label="امکان باز کردن مجدد تیکت‌های بسته شده" v-model="form.reopen_closed_tickets"></v-checkbox>
            <v-checkbox v-if="$system.license.features.ticket_auto_assignment" class="mt-0 mb-5" hide-details label="نمایش تیکت‌های مربوط به یک سرویس/محصول/دسته‌بندی به تمام کارمندان دارای دسترسی" v-model="form.show_ata_tickets_to_all_users"></v-checkbox>
            <div v-if="$system.license.features.satisfaction_ticket || $system.license.features.satisfaction_reply">
                <custom-divider label="تنظیمات نظرسنجی تیکت"></custom-divider>
                <v-checkbox class="mt-0 mb-2" hide-details label="نمایش نظرسنجی هر پاسخ تیکت به مشتریان" v-model="form.satisfaction_from_customers_reply" v-if="$system.license.features.satisfaction_reply"></v-checkbox>
                <v-checkbox class="mt-0 mb-3" hide-details label="نمایش نظرسنجی کلی به مشتریان پس از بسته شدن تیکت" v-model="form.satisfaction_from_customers_ticket" v-if="$system.license.features.satisfaction_ticket"></v-checkbox>
                <div v-if="$system.license.features.without_satisfaction_tickets_limit" class="d-flex align-center mb-3">
                    <p class="text-meta mb-0 text-grey-darken-2">حداکثر تیکت های بسته شده بدون مشارکت در نظرسنجی برای هر مشتری</p>
                    <v-text-field
                        hide-details
                        style="width:50px"
                        variant="underlined"
                        class="mx-2 flex-shrink-0 flex-grow-0"
                        v-model="form.without_satisfaction_customer_tickets_limit"
                    ></v-text-field>
                    <v-icon v-tooltip="'در صورتی که مشتریان این تعداد تیکت بسته شده بدون ثبت نظرسنجی داشته باشند، امکان ثبت تیکت جدید را نخواهند داشت. \nعدد صفر به منزله عدم اعمال این محدودیت خواهد بود'" class="cursor-help" color="secondary" size="18">info</v-icon>
                </div>
                <v-checkbox class="mt-0 mb-2" hide-details label="نمایش نظرسنجی هر پاسخ تیکت به کاربران سازمانی" v-model="form.satisfaction_from_employees_reply" v-if="$system.license.features.satisfaction_reply"></v-checkbox>
                <v-checkbox class="mt-0 mb-3" hide-details label="نمایش نظرسنجی کلی به کاربران سازمانی در تیکت های درون سازمانی پس از بسته شدن تیکت" v-model="form.satisfaction_from_employees_ticket" v-if="$system.license.features.satisfaction_ticket"></v-checkbox>
                <div v-if="$system.license.features.without_satisfaction_tickets_limit" class="d-flex align-center mb-3">
                    <p class="text-meta mb-0 text-grey-darken-2">حداکثر تیکت های بسته شده بدون مشارکت در نظرسنجی برای هر کاربر سازمانی</p>
                    <v-text-field
                        hide-details
                        style="width:50px"
                        variant="underlined"
                        class="mx-2 flex-shrink-0 flex-grow-0"
                        v-model="form.without_satisfaction_employee_tickets_limit"
                    ></v-text-field>
                    <v-icon v-tooltip="'در صورتی که کاربران سازمانی این تعداد تیکت بسته شده بدون ثبت نظرسنجی داشته باشند، امکان ثبت تیکت جدید را نخواهند داشت. \nعدد صفر به منزله عدم اعمال این محدودیت خواهد بود'" class="cursor-help" color="secondary" size="18">info</v-icon>
                </div>
            </div>
            <custom-divider label="تنظیمات بسته شدن تیکت"></custom-divider>
            <div class="d-flex align-center mb-3">
                <p class="text-meta mb-0 text-grey-darken-2">اجازه بستن تیکت توسط</p>
                <v-select
                    :items="[{ name: 'ایجاد کننده', id: 'owner' }, { name: 'گیرندگان', id: 'recipients' }, { name: 'همه کاربران', id: 'all' }]"
                    hide-details
                    item-title="name"
                    item-value="id"
                    label="انتخاب کنید"
                    class="mx-2"
                    style="max-width:150px"
                    v-model="form.ticket_closing_permission"
                ></v-select>
            </div>
            <div v-if="$system.license.features.ticket_auto_closing">
                <div class="d-flex align-center">
                    <time-picker-input
                        v-model="form.auto_closing_employee_tickets_time"
                        label="مدت زمان بسته شدن خودکار تیکت‌های غیرفعال کاربران سازمانی به مشتریان"
                        clearable
                    ></time-picker-input>
                    <v-icon v-tooltip="'با گذشت این زمان، در صورت عدم دریافت پاسخ جدید برای تیکت هایی که کاربران سازمانی ایجاد کننده آنها می باشند، تیکت به صورت خودکار بسته خواهد شد'" class="cursor-help" color="secondary" size="18">info</v-icon>
                </div>
                <div class="d-flex align-center">
                    <time-picker-input
                        v-model="form.auto_closing_customer_tickets_time"
                        label="مدت زمان بسته شدن خودکار تیکت‌های غیرفعال مشتریـان به کاربران سازمانی"
                        clearable
                    ></time-picker-input>
                    <v-icon v-tooltip="'با گذشت این زمان، در صورت عدم دریافت پاسخ جدید برای تیکت هایی که مشتریان ایجاد کننده آنها می باشند، تیکت به صورت خودکار بسته خواهد شد'" class="cursor-help" color="secondary" size="18">info</v-icon>
                </div>
            </div>
            <div class="mt-4">
                <v-btn @click="submit" class="mt-4 " color="success" :loading="loading">ثبت اطلاعات</v-btn>
                <v-btn @click="$router.push({path: '/settings'})" class="ms-3 " color="error" variant="text" :disabled="loading">بازگشت به تنظیمات</v-btn>
            </div>
        </v-col>
    </div>
</template>

<script>
export default {
    title: "تنظیمات عمومی تیکت",
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            loading: false,
            formPermissionList: {
                satisfaction_from_customers_ticket: this.$system.license.features.satisfaction_ticket,
                satisfaction_from_employees_ticket: this.$system.license.features.satisfaction_ticket,
                without_satisfaction_customer_tickets_limit: this.$system.license.features.without_satisfaction_tickets_limit,
                without_satisfaction_employee_tickets_limit: this.$system.license.features.without_satisfaction_tickets_limit,
                satisfaction_from_customers_reply: this.$system.license.features.satisfaction_reply,
                satisfaction_from_employees_reply: this.$system.license.features.satisfaction_reply,
                show_ata_tickets_to_all_users: this.$system.license.features.ticket_auto_assignment,
                auto_closing_customer_tickets_time: this.$system.license.features.ticket_auto_closing,
                auto_closing_employee_tickets_time: this.$system.license.features.ticket_auto_closing,
            },
            form: {
                reopen_closed_tickets: this.$system.settings.reopen_closed_tickets,
                ticket_closing_permission: this.$system.settings.ticket_closing_permission,
                satisfaction_from_customers_ticket: null,
                satisfaction_from_employees_ticket: null,
                without_satisfaction_customer_tickets_limit: null,
                without_satisfaction_employee_tickets_limit: null,
                satisfaction_from_customers_reply: null,
                satisfaction_from_employees_reply: null,
                show_ata_tickets_to_all_users: null,
                auto_closing_customer_tickets_time: null,
                auto_closing_employee_tickets_time: null,
            },
        };
    },
    methods: {
        submit() {
            this.loading = true;
            this.$updateSettings({...this.form, _method: 'put'}).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.$system.setGlobalSettings(true);
                }
            }).finally(()=>{this.loading = false});
        },
    },
    created() {
        for (const key in this.formPermissionList) {
            if (this.formPermissionList[key])
                this.form[key] = Array.isArray(this.$system.settings[key]) ? [...this.$system.settings[key]] : this.$system.settings[key];
            else
                delete this.form[key];
        }
    },
};
</script>
